import { createReducer } from 'lib/utilities.js';

const randomAccessHash = (min, max) => {
  let val = Math.floor(Math.random() * (max - min + 1)) + min;
  return val.toString();
};

const initialState = {
  username: '',
  roomName: '',
  friendlyRoomName: '',
  roomID: '',
  token: null,
  accessCode: randomAccessHash(11111, 99999),
  loadingRoom: false,
  rooms: [],
  fullScreenMode: false,
  shortUrl: null,
};

export default createReducer(initialState, {
  MINIMIZE_VIDEO: (state) => ({ ...state, fullScreenMode: false }),

  SET_LOADING_ROOM: (state, payload) => ({ ...state, loadingRoom: payload }),

  SET_LOADING_ROOM_AND_FULLSCREEN: (state, payload) => ({
    ...state,
    fullScreenMode: payload,
    loadingRoom: payload,
  }),

  SET_IS_FULLSCREEN: (state, payload) => ({ ...state, fullScreenMode: payload }),

  SET_IS_FULLSCREEN_WITH_LOADER: (state, payload) => ({ ...state, fullScreenMode: payload, loadingRoom: payload }),

  SET_USERNAME: (state, payload) => ({ ...state, username: payload }),

  SET_ROOM_NAME: (state, payload) => ({ ...state, roomName: payload }),

  SET_FRIENDLY_ROOM_NAME: (state, payload) => ({
    ...state,
    friendlyRoomName: payload,
  }),

  SET_ACCESS_CODE: (state, payload) => ({ ...state, accessCode: payload }),

  SET_ROOM_ID: (state, payload) => ({ ...state, roomID: payload }),

  SET_JOIN_ROOM_ON_CLICK: (state, payload) => ({
    ...state,
    roomName: payload.roomName,
    roomID: payload.roomID,
    username: payload.username,
    accessCode: payload.accessCode,
  }),

  POST_VIDEO_CHAT_ROOM_SUCCESS: (state, payload) => ({
    ...state,
    roomName: payload.data.room_name,
    roomID: payload.data.room_id,
    username: `${payload.data.user.first_name} ${payload.data.user.last_name}`,
  }),

  GET_SHORT_URL_SUCCESS: (state, payload) => ({ ...state, shortUrl: payload.data.shortUrl }),

  GET_VIDEO_CHAT_TOKEN_SUCCESS: (state, payload) => ({ ...state, token: payload.data.token }),

  GET_AVAILABLE_ROOMS_SUCCESS: (state, payload) => ({ ...state, rooms: payload.data }),

  RESET_VIDEO_STATE: (state) => ({
    ...initialState,
    rooms: state.rooms,
    accessCode: randomAccessHash(11111, 99999),
  }),
});
